module.exports = "<app-header-nav></app-header-nav>\r\n<!-- begin::Body -->\r\n\r\n<router-outlet></router-outlet>\r\n<app-footer></app-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/theme.component.html
// module id = ./src/app/theme/theme.component.html
// module chunks = main